(function () {
  'use strict';

  var doc = document;
  var html = doc.documentElement;
  var observer = null;
  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
  var revealSelector = '[data-damder-reveal]';
  var homeSelector = [
    '.main-banner',
    '.damder_home_section1',
    '.damder_home_section2',
    '.damder_home_section3',
    '.damder_home_section3-2',
    '.damder_home_section3-3',
    '.damder_home_section4',
    '.damder_home_section5',
    '.damder-etrog-guide'
  ].join(',');
  var scrollTicking = false;

  function animateCount(element) {
    if (!element || element.hasAttribute('data-damder-counted')) return;

    var target = Number(element.getAttribute('data-damder-count'));
    if (!isFinite(target)) return;

    element.setAttribute('data-damder-counted', 'true');

    if (reduceMotion && reduceMotion.matches) {
      element.textContent = String(target);
      return;
    }

    var startedAt = null;
    var duration = 1250;

    function step(timestamp) {
      if (startedAt === null) startedAt = timestamp;

      var progress = Math.min((timestamp - startedAt) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      element.textContent = String(Math.round(target * eased));

      if (progress < 1) {
        window.requestAnimationFrame(step);
      } else {
        element.textContent = String(target);
      }
    }

    element.textContent = '0';
    window.requestAnimationFrame(step);
  }

  function startCounters(scope) {
    var counters = [];
    var index;

    if (scope.matches && scope.matches('[data-damder-count]')) counters.push(scope);
    counters = counters.concat(Array.prototype.slice.call(scope.querySelectorAll('[data-damder-count]')));

    for (index = 0; index < counters.length; index += 1) {
      animateCount(counters[index]);
    }
  }

  function updateScrollProgress() {
    var root = doc.documentElement;
    var maximum = Math.max(root.scrollHeight - window.innerHeight, 1);
    var progress = Math.min(Math.max(window.pageYOffset / maximum, 0), 1);

    doc.body.style.setProperty('--damder-scroll-progress', String(progress));
    scrollTicking = false;
  }

  function handleScroll() {
    if (scrollTicking) return;

    scrollTicking = true;
    window.requestAnimationFrame(updateScrollProgress);
  }

  function reveal(element) {
    if (!element) return;

    element.classList.add('is-revealed');
    startCounters(element);
    if (observer) observer.unobserve(element);
  }

  function revealAll() {
    var elements = doc.querySelectorAll(revealSelector);
    var index;

    for (index = 0; index < elements.length; index += 1) {
      reveal(elements[index]);
    }
  }

  function register(element, delay, variant) {
    if (!element || element.hasAttribute('data-damder-motion-bound')) return;

    if (!element.hasAttribute('data-damder-reveal')) {
      element.setAttribute('data-damder-reveal', variant || 'soft');
    }
    element.setAttribute('data-damder-motion-bound', 'true');
    element.style.setProperty('--damder-reveal-delay', String(delay || 0) + 'ms');

    if (observer) {
      observer.observe(element);
    } else {
      reveal(element);
    }
  }

  function registerScope(scope) {
    if (!scope) return;
    if (!(scope.matches && scope.matches(homeSelector)) && !scope.querySelector(homeSelector)) return;

    var heroCopies = scope.querySelectorAll('.main-banner .slider-cont');
    var introHeadings = scope.querySelectorAll('.damder_home_section1 .heading_block');
    var introCopies = scope.querySelectorAll('.damder_home_section1 .damder-sec1-copy');
    var introMedia = scope.querySelectorAll('.damder_home_section1 .damder-sec1-media');
    var headings = scope.querySelectorAll('.damder_home_section2 .section_heading');
    var proofStrips = scope.querySelectorAll('.damder-proof-strip');
    var cards = scope.querySelectorAll('.damder_home_section2 .hoshen-stone-col');
    var valueElements = scope.querySelectorAll([
      '.damder-b2b-value__heading',
      '.damder-b2b-value__card',
      '.damder-b2b-value__quote'
    ].join(','));
    var sectionRoots = scope.querySelectorAll([
      '.damder_home_section3',
      '.damder_home_section3-2',
      '.damder_home_section3-3',
      '.damder_home_section4',
      '.damder_home_section5'
    ].join(','));
    var index;

    for (index = 0; index < heroCopies.length; index += 1) {
      register(heroCopies[index], Math.min(index * 50, 100), 'soft');
    }

    for (index = 0; index < introHeadings.length; index += 1) {
      register(introHeadings[index], 0, 'soft');
    }

    for (index = 0; index < introCopies.length; index += 1) {
      register(introCopies[index], 60, 'soft');
    }

    for (index = 0; index < introMedia.length; index += 1) {
      register(introMedia[index], 100 + (index * 70), 'lift');
    }

    for (index = 0; index < headings.length; index += 1) {
      register(headings[index], 0, 'soft');
    }

    for (index = 0; index < proofStrips.length; index += 1) {
      register(proofStrips[index], 40, 'soft');
    }

    for (index = 0; index < cards.length; index += 1) {
      register(cards[index], Math.min(index * 70, 280), 'lift');
    }

    for (index = 0; index < valueElements.length; index += 1) {
      register(valueElements[index], Math.min(index * 65, 325), index === 0 ? 'soft' : 'lift');
    }

    for (index = 0; index < sectionRoots.length; index += 1) {
      register(sectionRoots[index], 0, 'soft');
    }
  }

  function createObserver() {
    if (!('IntersectionObserver' in window)) return null;

    return new IntersectionObserver(function (entries) {
      var index;

      for (index = 0; index < entries.length; index += 1) {
        if (entries[index].isIntersecting || entries[index].intersectionRatio > 0) {
          reveal(entries[index].target);
        }
      }
    }, {
      root: null,
      rootMargin: '0px 0px 18% 0px',
      threshold: 0.03
    });
  }

  function handleReducedMotion(event) {
    if (!event.matches) return;

    if (observer) observer.disconnect();
    observer = null;
    revealAll();
  }

  function init() {
    var main = doc.getElementById('MainContent');

    if (!main || !main.querySelector(homeSelector)) return;

    if (reduceMotion && reduceMotion.matches) return;

    doc.body.classList.add('damder-home-motion');
    observer = createObserver();
    registerScope(main);
    html.classList.add('damder-motion-ready');
    updateScrollProgress();
    window.addEventListener('scroll', handleScroll, { passive: true });

    if (!observer) revealAll();

    if (reduceMotion) {
      if (reduceMotion.addEventListener) {
        reduceMotion.addEventListener('change', handleReducedMotion);
      } else if (reduceMotion.addListener) {
        reduceMotion.addListener(handleReducedMotion);
      }
    }
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  doc.addEventListener('shopify:section:load', function (event) {
    if (reduceMotion && reduceMotion.matches) return;

    registerScope(event.target);
    html.classList.add('damder-motion-ready');
  });

  doc.addEventListener('shopify:block:select', function (event) {
    var element = event.target.closest ? event.target.closest(revealSelector) : null;
    reveal(element);
  });
}());
